import { Link } from "gatsby";
import React from "react";
import * as styles from "./parts.module.scss";

export const Copyright = () => (
  <div className={styles.copyright}>
    ©Tours-tourisme.fr - <Link to="/legals">Mentions légales</Link>
  </div>
);
